import React, { useState } from 'react';
//import ReactQuill from 'react-quill';
import { getFirestore, serverTimestamp } from "firebase/firestore";

import firebaseApp from "../firebase/credenciales";
//import 'react-quill/dist/quill.snow.css';
import '../styles/documentos.css'

import { Editor } from '@tinymce/tinymce-react';
import añadirDocumento from '../functions/añadirDocumento';
import alertaOk from '../functions/alertaOk';
import alertaError from '../functions/alertaError';


const Plantillas = ({ usuario }) => {

  const db = getFirestore(firebaseApp);
  const [registros, setRegistros] = React.useState([]);
  const [title, setTitle] = useState('');
  const [content, setContent] = useState('');
  const [htmlContent, setHtmlContent] = useState('');
  const [code, setCode] = useState('');
  const [tipoDoc, setTipoDoc] = useState("");


  const handleContentChange = (value) => {
    setContent(value);
    setHtmlContent(value)
  };

  const selectChange = (e) => {
    let tipo = e.target.value
    setTipoDoc(tipo)
  }

  const handleSubmit = async (e) => {
    e.preventDefault();

    //Verificar que todos los campos fueron llenados

    if (title.length !== 0 && htmlContent.length !== 0 && code.length !== 0) {

      //Grabar plantilla
      const infoDocumento = {
        activo: true,
        codigo: code,
        documento: htmlContent,
        fechaDoc: serverTimestamp(),
        nombre: title,
        ruc: usuario.ruc,
        tipo: tipoDoc,
      };

      const result = await añadirDocumento(infoDocumento, usuario.email, `plantillaDocumentos`, `Grabar Plantilla`)
      console.log(result)
      // Add a new document with a generated id.
      /*const docRef = await addDoc(collection(db, "plantillaDocumentos"), {
        nombre: title,
        documento: htmlContent,
        codigo: codigo,
        activo: true,
        fechaDoc: serverTimestamp(),
        ruc: ruc,
      });
      console.log("Document written with ID: ", docRef.id);*/
      if (result.length === 20) {
        alertaOk(`Plantilla gaurdada con éxito`)
      } else {
        alertaError("No se guardo la plantilla, intentelo nuevamente")
      }
    } else {
      alertaError("Completa todos los campos porfavor.")
    }

  };

  return (
    <div className="form-container">
      <form onSubmit={handleSubmit}>
        <div style={{ marginBottom: "20px" }}>
          <input
            type="text"
            value={title}
            onChange={(e) => setTitle(e.target.value)}
            placeholder="Título del documento."
          />
        </div>

        <div>
          <input
            type="text"
            value={code}
            onChange={(e) => setCode(e.target.value)}
            placeholder="Código del documento."
          />
        </div>
        <div>
          <br />
          <select onChange={selectChange} defaultValue={'DEFAULT'} className="form-select" aria-label="Default select example">
            <option value="DEFAULT" disabled>ELIGE EL TIPO DE DOCUMENTO</option>
            <option value="Boletas de pago">BOLETAS DE PAGO</option>
            <option value="CTS">CTS</option>
            <option value="Contratos">CONTRATOS</option>
            <option value="Renta">RENTA DE 5TA</option>
            <option value="Memorandums">MEMORANDUMS</option>
            <option value="Utilidades">UTILIDADES</option>
            <option value="Vacaciones">VACACIONES</option>
            <option value="Prestamos">PRESTAMOS</option>
            <option value="Adelantos">ADELANTOS</option>
            <option value="Otros">OTROS</option>
          </select>
        </div>

        <div style={{ display: 'inline-block', width: '100%', backgroundColor: 'white', marginTop: '20px', marginBottom: '20px' }}>
          <div style={{ float: 'left', width: '50%' }}>
            <Editor
              id="content"
              apiKey="tksbzuit5ws3y80onpfvij37te4mc8k7z9bjqctzp9jbs6hf"
              value={content}
              init={{
                height: 1000,
                menubar: 'file edit view format',
                plugins: [
                  'advlist autolink lists link image imagetools charmap print preview anchor',
                  'searchreplace visualblocks code fullscreen',
                  'insertdatetime media table paste code help wordcount',
                ],
                toolbar:
                  'undo redo | formatselect | bold italic backcolor | \
              alignleft aligncenter alignright alignjustify | \
              bullist numlist outdent indent | removeformat | help | image',
              }}
              onEditorChange={handleContentChange}
            />
          </div>

          <div dangerouslySetInnerHTML={{ __html: htmlContent }}
            style={{
              float: 'left',
              width: '50%',
              paddingLeft: '10px',
              border: '1px solid #D3D3D3',
              padding: '10px',
              backgroundColor: 'white',
              fontSize: '13px'
            }} />

          {/*
          Contenedor para ver las etiquetas HTML*/}

          <div>
            <textarea value={htmlContent}
              style={{
                width: '100%',
                height: '400px',
              }} />
          </div>
        </div>
        {/*<div>
        <label>Fecha:</label>
        <input
          type="text"
          value={date}
          onChange={(e) => setDate(e.target.value)}
        />
        </div>*/}

        <button type="submit">Publicar</button>
      </form>
    </div>
  );
};

export default Plantillas;
